import AdminApprovalsModule from '@/modules/admin-approvals';
import { createFileRoute } from '@tanstack/react-router';
import { useAccessControl } from '../../../hooks/useAccessControl';
import { AccessDenied } from '../../../components/ui/access-denied';

export const Route = createFileRoute('/dashboard/admin-approvals/')({
  component: AdminApprovalsPage,
});

function AdminApprovalsPage() {
  const { canAccessHorizonTemplateRequests } = useAccessControl();
  if (!canAccessHorizonTemplateRequests) {
    return <AccessDenied />;
  }
  return <AdminApprovalsModule />;
}
